"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnigmaticCapacityAbilityHandler = exports.EnigmaticCapacityActorAbilityFactory = exports.EnigmaticCapacityAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class EnigmaticCapacityAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EnigmaticCapacity;
        this.__typeName = "EnigmaticCapacity";
    }
}
exports.EnigmaticCapacityAbilityArgs = EnigmaticCapacityAbilityArgs;
let EnigmaticCapacityActorAbilityFactory = class EnigmaticCapacityActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EnigmaticCapacity", "AllAllies", 3);
    }
};
EnigmaticCapacityActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EnigmaticCapacity")
], EnigmaticCapacityActorAbilityFactory);
exports.EnigmaticCapacityActorAbilityFactory = EnigmaticCapacityActorAbilityFactory;
let EnigmaticCapacityAbilityHandler = class EnigmaticCapacityAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 10),
            duration: Duration_1.Duration.Permanent,
            onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(actorId, "chest"), "BlueCircles"))
        });
    }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies).filter(allyId => allyId !== ability.invokerId)
                    .forEach(targetId => {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId,
                        effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 10),
                        duration: Duration_1.Duration.Turns(3),
                        onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(
                        // isn't placed on origin, so move to feet and it'll be above the feet some amount
                        new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "FierySphericalSwirls"))
                    });
                });
            }
        });
    }
};
EnigmaticCapacityAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EnigmaticCapacity)
], EnigmaticCapacityAbilityHandler);
exports.EnigmaticCapacityAbilityHandler = EnigmaticCapacityAbilityHandler;
